import { router } from "umi";
import request from "@/utils/request";
import { getRouteByPath } from "@/utils/route";
import { stopTrackingLoggedInUserForDatadog } from "@/utils/setupDatadog";
import { setSessionStorage, removeSessionStorage, getSessionStorage, getLocalStorage, setLocalStorage, removeLocalStorage, } from "@/utils/storage";
function setLoginData(resp) {
    let data;
    let response;
    if (resp.response) {
        data = resp.data;
        response = resp.response;
    }
    if (response?.ok) {
        setLocalStorage("dataAuth", data);
    }
    if (response) {
        return response;
    }
    return resp;
}
const redirectFn = (username) => {
    if (!username) {
        router.replace("");
        return;
    }
    // look for redirect url in local storage and remove it after use
    const redirectUrlForUserKey = `redirectUrl-${username}`;
    const redirectUrlForUser = getSessionStorage(redirectUrlForUserKey);
    const redirectUrl = `/${redirectUrlForUser ? `?redirectTo=${redirectUrlForUser}` : ""}`;
    removeSessionStorage(redirectUrlForUserKey);
    // let's put the redirect url in the / url params, RedirectLayout will handle it properly (by checking if the
    // current user has permissions to access to redirectUrlForUser)
    router.replace(redirectUrl);
};
export async function login({ username, password }) {
    const data = {
        grant_type: "password",
        client_id: REACT_APP_CLIENT_ID,
        scope: REACT_APP_SCOPE,
        username,
        password,
    };
    const loginResponse = await request(`${REACT_APP_IDENTITY_SERVER_BASE_URL}/connect/token`, {
        method: "POST",
        body: new URLSearchParams(Object.entries(data)).toString(),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    });
    // store login data
    setLoginData(loginResponse);
    // if response is ok, redirect the user
    if (loginResponse?.response?.ok) {
        redirectFn(data.username);
        return { ok: true };
    }
    return { error: loginResponse.error };
}
export async function startAccountImpersonation({ userId, currentProfile, cleanConfigPerm, }) {
    setSessionStorage("impersonatorAdminUserEmail", currentProfile.email);
    const { pathname, search } = window.location;
    const route = getRouteByPath(pathname);
    if (route && !route.cannotRedirectTo) {
        // The impersonator is looking at this url so shouldn't need to check if it has permissions to access it, but just
        // in case
        const redirectUrlForUserKey = `redirectUrl-${currentProfile.email}`;
        setSessionStorage(redirectUrlForUserKey, pathname + search);
    }
    const authData = getLocalStorage("dataAuth");
    const data = {
        client_id: `${REACT_APP_CLIENT_ID}`,
        grant_type: "Impersonation",
        scope: REACT_APP_SCOPE,
        access_token: authData.access_token,
        UserId: userId,
    };
    const impersonateResponse = await request(`${REACT_APP_IDENTITY_SERVER_BASE_URL}/connect/token`, {
        method: "POST",
        data: new URLSearchParams(Object.entries(data)).toString(),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    });
    if (impersonateResponse?.response?.ok) {
        await cleanConfigPerm();
        setLoginData(impersonateResponse);
        router.replace("/");
    }
    return impersonateResponse;
}
export async function endAccountImpersonation({ cleanConfigPerm }) {
    const authData = getLocalStorage("dataAuth");
    const adminUserEmail = getSessionStorage("impersonatorAdminUserEmail");
    removeSessionStorage("impersonatorAdminUserEmail");
    const redirectUrlForUserKey = `redirectUrl-${adminUserEmail}`;
    const redirectTo = getSessionStorage(redirectUrlForUserKey);
    removeSessionStorage(redirectUrlForUserKey);
    const data = {
        client_id: `${REACT_APP_CLIENT_ID}`,
        grant_type: "Impersonation",
        scope: REACT_APP_SCOPE,
        access_token: authData.access_token,
        UserId: undefined,
    };
    const endImpersonationResponse = await request(`${REACT_APP_IDENTITY_SERVER_BASE_URL}/connect/token`, {
        method: "POST",
        data: new URLSearchParams(Object.entries(data)).toString(),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    });
    if (endImpersonationResponse?.response?.ok) {
        setLoginData(endImpersonationResponse);
        await cleanConfigPerm();
        const redirectUrl = `/${redirectTo ? `?redirectTo=${redirectTo}` : ""}`;
        router.replace(redirectUrl);
    }
    return endImpersonationResponse;
}
export async function revokeToken({ token }) {
    const data = {
        client_id: REACT_APP_CLIENT_ID,
        token,
    };
    const revokeTokenRequest = await request(`${REACT_APP_IDENTITY_SERVER_BASE_URL}/connect/revocat`, {
        method: "POST",
        data: new URLSearchParams(Object.entries(data)).toString(),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    });
    removeLocalStorage("dataAuth");
    return revokeTokenRequest;
}
export async function logout(username) {
    try {
        const { pathname, search } = window.location;
        const dataAuth = getLocalStorage("dataAuth");
        const token = dataAuth?.refresh_token;
        const route = getRouteByPath(pathname);
        if (username && route !== null && !route.cannotRedirectTo) {
            // save current page for this user for this session
            setSessionStorage(`redirectUrl-${username}`, pathname + search);
        }
        if (token) {
            await revokeToken({ token });
        }
        stopTrackingLoggedInUserForDatadog();
        return { ok: true };
    }
    catch (error) {
        console.error(error);
        return { error };
    }
}
export async function refreshToken() {
    const dataAuthGet = getLocalStorage("dataAuth");
    const refreshTokenStr = dataAuthGet?.refresh_token;
    const data = {
        client_id: `${REACT_APP_CLIENT_ID}`,
        grant_type: "refresh_token",
        scope: REACT_APP_SCOPE,
        refresh_token: refreshTokenStr,
    };
    const refreshTokenRequest = await request(`${REACT_APP_IDENTITY_SERVER_BASE_URL}/connect/token`, {
        method: "POST",
        data: new URLSearchParams(Object.entries(data)).toString(),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    });
    return setLoginData(refreshTokenRequest);
}
